module.exports = __webpack_public_path__ + "img/small-facebook.21a7bc67.svg";